import { render, staticRenderFns } from "./Rating.vue?vue&type=template&id=f966f46e&scoped=true&"
import script from "./Rating.vue?vue&type=script&lang=js&"
export * from "./Rating.vue?vue&type=script&lang=js&"
import style0 from "./Rating.vue?vue&type=style&index=0&id=f966f46e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f966f46e",
  null
  
)

export default component.exports